{
  "name": "savings-account-admin",
  "type": "module",
  "version": "1.5.1-develop.0",
  "scripts": {
    "watch": "ng test",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "install": "cp ./package.json ./src/assets",
    "lint": "ng lint",
    "ng": "ng",
    "start": "ng serve --ssl --host localhost.sparbanken.me",
    "style-lint": "stylelint  \"src/**/*.scss\" --fix",
    "test": "ng test --watch=false --coverage"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.2",
    "@angular/common": "^22.2.2",
    "@angular/compiler": "^22.2.2",
    "@angular/core": "^22.2.2",
    "@angular/forms": "^22.2.2",
    "@angular/platform-browser": "^22.2.2",
    "@angular/platform-browser-dynamic": "^22.2.2",
    "@angular/router": "^22.2.2",
    "@eslint/js": "^10.0.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^22.2.2",
    "@angular/cdk": "^22.2.2",
    "@angular/cli": "^22.2.2",
    "@angular/compiler-cli": "^22.2.2",
    "@angular/material": "^22.2.2",
    "@sparbanken-syd/auth-backend": "^2.7.1",
    "@sparbanken-syd/personnummer": "^3.1.0",
    "@sparbanken-syd/sparbanken-syd-bankid": "^22.0.0",
    "@sparbanken-syd/sparbanken-syd-qr": "^22.0.2",
    "@sparbanken-syd/sparbanken-syd-theme": "^22.1.0",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^22.0.0",
    "@sparbanken-syd/spb-savings-account-backend": "^1.4.1",
    "@standard-schema/spec": "^1.1.0",
    "@types/node": "^24",
    "@typescript-eslint/eslint-plugin": "^8.71.2",
    "@typescript-eslint/parser": "^8.71.2",
    "@vitest/coverage-v8": "^5.0.4",
    "angular-eslint": "^22.6.0",
    "echarts": "^6.0.0",
    "eslint": "^10.12.0",
    "jsdom": "^30.1.1",
    "ngx-echarts": "^22.0.0",
    "postcss": "^8.5.30",
    "stylelint": "^17.16.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "stylelint-scss": "^7.3.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.71.2",
    "vite": "^8.3.4",
    "vitest": "^5.0.4"
  }
}
